export function totalXpAtLevel(level: number): number {
  if (!Number.isInteger(level) || level < 1)
    throw new RangeError("level must be a positive integer");
  return Math.floor((50 * (level ** 3 - 6 * level ** 2 + 17 * level - 12)) / 3);
}

export function xpToNextLevel(level: number): number {
  if (!Number.isInteger(level) || level < 1)
    throw new RangeError("level must be a positive integer");
  return 50 * (level ** 2 - 3 * level + 4);
}

export function levelForTotalXp(totalXp: number): number {
  if (!Number.isFinite(totalXp) || totalXp < 0)
    throw new RangeError("totalXp must be non-negative");
  let low = 1;
  let high = 2;
  while (totalXpAtLevel(high) <= totalXp) high *= 2;
  while (low + 1 < high) {
    const mid = Math.floor((low + high) / 2);
    if (totalXpAtLevel(mid) <= totalXp) low = mid;
    else high = mid;
  }
  return low;
}

export function awardXp(
  totalXp: number,
  awardedXp: number,
): { totalXp: number; level: number; levelsGained: number } {
  if (!Number.isFinite(awardedXp) || awardedXp < 0)
    throw new RangeError("awardedXp must be non-negative");
  const oldLevel = levelForTotalXp(totalXp);
  const nextTotalXp = Math.floor(totalXp + awardedXp);
  const level = levelForTotalXp(nextTotalXp);
  return { totalXp: nextTotalXp, level, levelsGained: level - oldLevel };
}
